export const config = {
  id: 'mobile',
  icon: 'Smartphone',
  color: 'indigo',
  title: 'Mobile Developer',
  description: 'iOS and Android app development with native and cross-platform technologies',
  department: 'Engineering',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 7,
    mid: 5,
    senior: 3
  }
};
